<template>
  <el-dropdown
    trigger="click"
    :hide-on-click="false"
    @visible-change="saveTableColumn"
  >
    <!-- <el-button class="table-set" icon="icon icon-tableset"></el-button> -->
    <div class="btn-table-set">
      <i class="icon icon-biaogeshezhi"></i>
    </div>
    <el-dropdown-menu
      slot="dropdown"
      class="custom-dropdown"
    >
      <el-dropdown-item>
        <el-checkbox
          v-model="isAllColumn"
          @change="setAllColumn"
        >{{ $t('com_sel_all') }}</el-checkbox>
      </el-dropdown-item>
      <el-dropdown-item
        v-for="(item, i) in tableColumn"
        :key="i"
      >
        <el-checkbox
          v-model="item.selected"
          @change="formatTable"
        >{{ item.columnCode === 'action' ? $t('com_action') : item.columnName }}</el-checkbox>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import apis from '@/utils/apis';



export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    code: [String],
    link: [Object]
  },
  data() {
    return {
      tableCode: '',
      isAllColumn: false,
      tableColumn: this.value
    };
  },
  watch: {
    value(newVal) {
      this.tableColumn = newVal;
      this.formatTable();
    },
  },
  mounted() {
    this.formatTable();
    // this.getCompLanguage();
  },
  methods: {
    // 格式化表格
    formatTable: function () {
      this.isAllColumn = !this.tableColumn.find(t => !t.selected);
      this.$emit('input', this.tableColumn);
    },
    // 保存自定义列
    saveTableColumn: function (value) {
      if (!value) {
        const columnIds = this.tableColumn.filter(t => t.selected).map(t => t.columnId);
        this.$postJSON(apis.TableColumSet, {
          columnIds: columnIds,
          tableCode: this.code || this.tableCode
        }).then(() => { });
      }
    },
    // 设置列全选
    setAllColumn: function (value) {
      this.tableColumn.forEach((item) => {
        item.selected = value;
      });
      this.formatTable();
    }
  }
};
</script>
<style lang="scss">
.custom-dropdown {
  .el-checkbox__label {
    font-weight: normal;
  }
}

.btn-table-set {
  display: inline-block;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 100%;
  box-shadow: 0 0 0 1.5px #202945 inset;
  background: #fff;

  .icon {
    font-size: 16px;
    color: #202945;
  }
}
</style>
